import { fetchWithAuth } from '../apiClient';

export async function fetchMyPushSubscriptions() {
  const res = await fetchWithAuth('/push-subscriptions', { method: 'GET' });
  return await res.json();
}

export async function registerPushSubscription(subscription, { deviceName, deviceType } = {}) {
  // Use subscription.toJSON() when available (keeps previous behavior)
  let payload = null;
  if (typeof subscription.toJSON === 'function') {
    payload = subscription.toJSON();
  } else {
    payload = {
      endpoint: subscription.endpoint,
      keys: subscription.keys || {}
    };
  }

  // Attach optional device metadata
  payload.deviceName = deviceName ?? null;
  payload.deviceType = deviceType ?? null;

  return await fetchWithAuth('/api/subscriptions', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload)
  });
}

export async function togglePushSubscription(id, disabled) {
  return await fetchWithAuth(`/push-subscriptions/${id}/disabled`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ disabled })
  });
}

export async function deletePushSubscription(id) {
  return await fetchWithAuth(`/push-subscriptions/${id}`, { method: 'DELETE' });
}
